<template>
    <div id="app">
        <smooth-scroll v-if="isLoaded" v-bind:security-culling="140">
            <router-view></router-view>
        </smooth-scroll>
        <div v-else class="u-fixed u-pos-tl u-fit u-flex u-align-items-c u-justify-content-c">
            <span class="u-color--white u-bold">{{pourcent}}%</span>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import WebFont from 'webfontloader';

    import throttle from '@/utilities/throttle';
    import Loader from '@/utilities/loader';

    import smoothScroll from '@/components/smoothScroll';

    export default {
        name: 'App',

        components: {
            smoothScroll,
        },

        data() {
            return {
                isLoaded: false,
                pourcent: 0,
            };
        },

        created() {
            // Listeners
            // --------------------
            window.addEventListener('resize', throttle(this.resize), false);
            window.addEventListener('orientationchange', throttle(this.resize, 1000), true);


            // Preload Font
            // --------------------
            WebFont.load({
                custom: {
                    families: ['DrukWide-Bold', 'Druk Text Medium Regular']
                },
                active:() => {
                    this.fontLoaded = true;
                    this.onLoaded();
                }
            });

            // Preload Image
            // --------------------

            const loader = new Loader();

            loader.onComplete = () => {
                this.assetsLoaded = true;
                this.onLoaded();
            };

            loader.onProgress = (pourcent) => { this.pourcent = Math.round(pourcent*100); };

            loader.add('/static/images/paper.jpg');
            loader.add('/static/images/florent-biffi.jpg');
            loader.add('/static/images/poster/yard.jpg');
            loader.add('/static/images/poster/unsilenced.jpg');
            loader.add('/static/images/poster/kinder.jpg');
            loader.add('/static/images/poster/generalpop.jpg');
            loader.add('/static/images/poster/adova.jpg');
            loader.add('/static/images/poster/airfrancemusic.jpg');
            loader.add('/static/images/poster/samsung.jpg');
            loader.add('/static/images/poster/milkmoments.jpg');
            loader.add('/static/images/poster/bouguessa.jpg');
            loader.add('/static/images/poster/lederniergaulois.jpg');
            loader.add('/static/images/poster/acme.jpg');
            loader.add('/static/images/poster/sevenhills.jpg');
            loader.add('/static/images/poster/reputationsquad.jpg');

            loader.load();
        },

        mounted() {
            this.resize();
            requestAnimationFrame(this.update.bind(this));
        },

        methods: {
            ...mapActions('window', {
                'resizeStore': 'resize',
            }),

            resize() {
                this.resizeStore();
                this.$eventHub.$emit('resize');
            },

            update() {
                this.$eventHub.$emit('update');
                requestAnimationFrame(this.update.bind(this));
            },

            onLoaded() {
                if (this.fontLoaded && this.assetsLoaded) {
                    this.isLoaded = true;
                }
            }
        },
    };
</script>

<style lang="stylus">
    @import './styles/styles.styl'
</style>